import { isRestrictedCountry } from '@platform/shared';
import { IP_COUNTRY } from './config';
import { createStore, useStore } from './store';

/** Set when the API refuses a request with `geo_blocked` (it may know more than the browser does). */
export const geoStore = createStore<{ refused: boolean }>({ refused: false });

export type GeoBlock = { country: string; basis: 'ip' | 'residence' | 'server' };

/**
 * Whether the platform is closed to this visitor: they connect from a restricted country (IP), their
 * profile says they live in one, or the API said so. Staff are exempt: admins, dealers, and a session opened
 * from the CRM ("Log in as client"; user decision 2026-10-11).
 */
export function useGeoBlock(me: { role: string; country: string | null; signedInBy?: string | null } | null): GeoBlock | null {
  const refused = useStore(geoStore, (s) => s.refused);
  if (me?.role === 'admin' || me?.role === 'dealer' || me?.signedInBy) return null;
  if (!me && (window.location.pathname === '/crm-login' || window.location.pathname === '/staff-login')) return null;
  if (isRestrictedCountry(IP_COUNTRY)) return { country: IP_COUNTRY, basis: 'ip' };
  if (me && isRestrictedCountry(me.country)) return { country: me.country!.toUpperCase(), basis: 'residence' };
  return refused ? { country: '', basis: 'server' } : null;
}
